import { c as _c } from "react/compiler-runtime";
import { IcoFaceid24, type Icon, IcoUsers24, IcoWarning24 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import NavigationHeader from '../../../components/navigation-header';
import type { IdDocImageErrorType } from '../../../types';
type RetryViewProps = {
  errors: IdDocImageErrorType[];
  onRetake: () => void;
};
type RetryReason = 'multiple-faces' | 'face-not-found' | 'fallback';
const ICONS: Record<RetryReason, Icon> = {
  'multiple-faces': IcoUsers24,
  'face-not-found': IcoFaceid24,
  fallback: IcoWarning24
};
const getRetryReason = (errorType?: IdDocImageErrorType['errorType']): RetryReason => {
  if (errorType === 'multiple_faces_detected') return 'multiple-faces';
  if (errorType === 'selfie_face_not_found' || errorType === 'face_not_found') return 'face-not-found';
  return 'fallback';
};
const RetryView = t0 => {
  const $0 = _c(35);
  const {
    errors,
    onRetake
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.selfie.pages.retry"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($0[1] !== errors[0]) {
    t2 = errors[0] ?? {};
    $0[1] = errors[0];
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  const {
    errorType,
    errorInfo
  } = t2;
  let t3;
  if ($0[3] !== errorType) {
    t3 = getRetryReason(errorType);
    $0[3] = errorType;
    $0[4] = t3;
  } else {
    t3 = $0[4];
  }
  const reason = t3;
  const ErrorIcon = ICONS[reason];
  let t4;
  if ($0[5] !== reason) {
    t4 = $ => $[reason].title;
    $0[5] = reason;
    $0[6] = t4;
  } else {
    t4 = $0[6];
  }
  let t5;
  if ($0[7] !== t || $0[8] !== t4) {
    t5 = t(t4);
    $0[7] = t;
    $0[8] = t4;
    $0[9] = t5;
  } else {
    t5 = $0[9];
  }
  const title = t5;
  let t6;
  if ($0[10] !== errorInfo || $0[11] !== reason || $0[12] !== t) {
    t6 = reason === "fallback" && errorInfo || t($_0 => $_0[reason].description);
    $0[10] = errorInfo;
    $0[11] = reason;
    $0[12] = t;
    $0[13] = t6;
  } else {
    t6 = $0[13];
  }
  const description = t6;
  let t7;
  if ($0[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NavigationHeader />;
    $0[14] = t7;
  } else {
    t7 = $0[14];
  }
  let t8;
  if ($0[15] !== ErrorIcon) {
    t8 = <ErrorIcon color="primary" />;
    $0[15] = ErrorIcon;
    $0[16] = t8;
  } else {
    t8 = $0[16];
  }
  let t9;
  if ($0[17] !== title) {
    t9 = <h2 className="text-heading-3 text-primary fp-text">{title}</h2>;
    $0[17] = title;
    $0[18] = t9;
  } else {
    t9 = $0[18];
  }
  let t10;
  if ($0[19] !== t8 || $0[20] !== t9) {
    t10 = <div className="flex items-center gap-2">{t8}{t9}</div>;
    $0[19] = t8;
    $0[20] = t9;
    $0[21] = t10;
  } else {
    t10 = $0[21];
  }
  let t11;
  if ($0[22] !== description) {
    t11 = <p className="text-body-2 text-secondary fp-text">{description}</p>;
    $0[22] = description;
    $0[23] = t11;
  } else {
    t11 = $0[23];
  }
  let t12;
  if ($0[24] !== t10 || $0[25] !== t11) {
    t12 = <div className="flex flex-col items-center gap-2 text-center">{t10}{t11}</div>;
    $0[24] = t10;
    $0[25] = t11;
    $0[26] = t12;
  } else {
    t12 = $0[26];
  }
  let t13;
  if ($0[27] !== t) {
    t13 = t(_temp);
    $0[27] = t;
    $0[28] = t13;
  } else {
    t13 = $0[28];
  }
  let t14;
  if ($0[29] !== onRetake || $0[30] !== t13) {
    t14 = <Button fullWidth={true} size="large" onClick={onRetake}>{t13}</Button>;
    $0[29] = onRetake;
    $0[30] = t13;
    $0[31] = t14;
  } else {
    t14 = $0[31];
  }
  let t15;
  if ($0[32] !== t12 || $0[33] !== t14) {
    t15 = <div className="flex h-full flex-col flex-1">{t7}<div className="flex flex-1 flex-col gap-6">{t12}{t14}</div></div>;
    $0[32] = t12;
    $0[33] = t14;
    $0[34] = t15;
  } else {
    t15 = $0[34];
  }
  return t15;
};
export default RetryView;
function _temp($_1) {
  return $_1.cta;
}